import { render, staticRenderFns } from "./TreeViewComponent.vue?vue&type=template&id=2e4f386e&scoped=true"
import script from "./TreeViewComponent.vue?vue&type=script&lang=js"
export * from "./TreeViewComponent.vue?vue&type=script&lang=js"
import style0 from "./TreeViewComponent.vue?vue&type=style&index=0&id=2e4f386e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4f386e",
  null
  
)

export default component.exports